// Minimal DuckDB row helper, free of project SQL and of Vue imports.
//
// Several components grew their own private `executeAndProcessQuery` that did
// nothing but `conn.query(sql)` -> `result.toArray().map(r => r.toJSON())`,
// each with a slightly different try/catch and coercion. This is that shared
// core. The chart-shaped variant (which also runs `processChartData`) stays in
// `stackedBarChartData.js` — use that one when the rows feed the base chart.
//
// Arrow returns BigInt for integer columns; callers coerce the numeric columns
// they care about (`Number(row.value)`), because only the caller knows which
// columns are numbers.

/**
 * Run a query and return its rows as plain JS objects.
 *
 * @param {{ query: (sql: string) => Promise<any> }} conn  a DuckDB connection
 * @param {string} sql
 * @returns {Promise<Object[]>}
 */
export const queryRows = async (conn, sql) => {
  const result = await conn.query(sql);
  return result.toArray().map((row) => row.toJSON());
};
